import { useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import Pressable from '@/theme/Pressable'
import PrimaryNavAccountMenu from '@/components/AccountMenu/PrimaryNavAccountMenu'
import { AccountMenuHeaderSlot } from '@/components/AccountMenu/AccountMenuHeaderSlot'
import { ACCOUNT_MENU_LIST_ID } from '@/components/AccountMenu/primaryNavConstants'
import { usePrimaryNavAccountMenu } from '@/components/AccountMenu/usePrimaryNavAccountMenu'
import UserProfileInitialsAvatar from '@/components/AccountMenu/UserProfileInitialsAvatar'
import { USER_PROFILE } from '@/config/userProfile'
import accountMenuStyles from '@/components/AccountMenu/accountMenu.module.scss'
import styles from './SecondaryNavAccountFooter.module.scss'



export default function SecondaryNavAccountFooter({
  onAccountMenuAction,
  accountFullName = USER_PROFILE.fullName,
  accountEmail = USER_PROFILE.email,
  iconOnly = false,
}) {
  const account = usePrimaryNavAccountMenu({ onAccountMenuAction })
  const accountMenuHeader = useMemo(
    () => <AccountMenuHeaderSlot accountFullName={accountFullName} accountEmail={accountEmail} />,
    [accountFullName, accountEmail],
  )

  return (
    <Box className={`${styles.footer} ${iconOnly ? styles.footerIconOnly : ''}`.trim()}>
      <Pressable
        className={`${styles.accountButton} ${iconOnly ? styles.accountButtonIconOnly : ''} ${accountMenuStyles.avatarShellButton}`.trim()}
        aria-label={`Account menu for ${accountFullName}`}
        aria-haspopup="menu"
        aria-expanded={account.accountMenuOpen}
        aria-controls={account.accountMenuOpen ? ACCOUNT_MENU_LIST_ID : undefined}
        onClick={account.handleAccountMenuOpen}
      >
        <Box className={accountMenuStyles.avatarShell}>
          <UserProfileInitialsAvatar fullName={accountFullName} size="sm" />
        </Box>
        {iconOnly ? null : (
          <Typography component="span" className={styles.accountName}>
            {accountFullName}
          </Typography>
        )}
      </Pressable>
      <PrimaryNavAccountMenu
        accountMenuOpen={account.accountMenuOpen}
        accountMenuAnchor={account.accountMenuAnchor}
        accountMenuHeader={accountMenuHeader}
        accountMenuItems={account.accountMenuItems}
        onClose={account.handleAccountMenuClose}
        onItemSelect={account.handleAccountItemSelect}
      />
    </Box>
  )
}
